import { Grid, styled } from '@mui/material';
import { LuBriefcase, LuBuilding, LuMegaphone, LuTag } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { ICandidateEmailLog } from 'wisestep-api';
import {
  WsChip,
  WsChipVariants,
  WsColors,
  WsIconText,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

const CustomContainerGrid = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.spacing(1.5),
  minHeight: 80,
  backgroundColor: WsColors.TertiaryShades50,
  borderRadius: theme.spacing(2),
}));

const CandidateEmailHeader = ({
  candidateEmailLog,
  isCampaignEmail,
}: {
  candidateEmailLog: ICandidateEmailLog;
  isCampaignEmail: boolean;
}) => {
  const navigate = useNavigate();
  const handleJobNavigation = () =>
    navigate(`/jobs-crm/${candidateEmailLog?.jobId}/false/0/pipeline`);
  return (
    <CustomContainerGrid>
      <Grid item container alignItems="center" columnGap={2}>
        <WsTypography
          variant={WsTypoVariants.TITLE}
          bold
          onClick={handleJobNavigation}
          cursor="pointer"
          color={WsTypoColors.PRIMARY600}
        >
          {candidateEmailLog?.jobTitle ?? `Job Title`}
        </WsTypography>
        {isCampaignEmail && (
          <WsChip
            value="campaign Email"
            variant={WsChipVariants.UNKNOWN}
            icon={<LuTag fontSize={16} color={WsColors.DefaultColor} />}
          />
        )}
      </Grid>
      <Grid item container alignItems="center" columnGap={2} ml={1}>
        <WsIconText
          icon={<LuBriefcase color={WsColors.TertiaryShades600} fontSize={18} />}
          text={candidateEmailLog?.jobCode ?? 'Not Available'}
          textSize={WsTypoVariants.BODY1}
        />
        <WsIconText
          icon={<LuBuilding color={WsColors.TertiaryShades600} height={18} width={18} />}
          text={candidateEmailLog?.clientName ?? 'Not Available'}
          textSize={WsTypoVariants.BODY1}
        />
        {isCampaignEmail && (
          <WsIconText
            icon={<LuMegaphone color={WsColors.TertiaryShades600} fontSize={18} />}
            text="View Campaign"
            textSize={WsTypoVariants.BODY1}
            textColor={WsTypoColors.PRIMARY600}
            textCursor="pointer"
            onClick={() =>
              navigate(
                `/jobs/job-email-campaign?jobId=${candidateEmailLog?.jobId}&campaignCode=${candidateEmailLog?.campaignCode}`
              )
            }
          />
        )}
      </Grid>
    </CustomContainerGrid>
  );
};

export default CandidateEmailHeader;
